import * as React from 'react';
import * as styles from './product.module.scss';
import { SEO } from '../../components/seo/seo';
import { MainTemplate } from '../main/main';
import { FormattedMessage, Link, useIntl } from 'gatsby-plugin-react-intl';
import { PageHeadline } from '../../components/page-headline/page-headline';
import { Carousel, CarouselItem } from '../../components/carousel/carousel';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { ButtonLink } from '../../components/button-link/button-link';
import { Routes } from '../../enum/Routes';
import { ROUTES } from '../../const/routes';
import { Chip } from '@material-ui/core';

interface IProps {
  location: Location;
  translationsKey: string;
  images: any;
}
export default function ProductTemplate({
  location,
  translationsKey,
  images,
}: IProps) {
  const intl = useIntl();
  const OTHER_CATEGORIES_LINKS = [
    {
      id: 'transport_boxes',
      label: intl.formatMessage({
        id: `products.products_data.transport_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_TRANSPORT_BOXES](),
    },
    {
      id: 'pizza_boxes',
      label: intl.formatMessage({
        id: `products.products_data.pizza_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_PIZZA_BOXES](),
    },
    {
      id: 'food_boxes',
      label: intl.formatMessage({
        id: `products.products_data.food_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_FOOD_BOXES](),
    },
    {
      id: 'luxury_laminated_boxes',
      label: intl.formatMessage({
        id: `products.products_data.luxury_laminated_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_LUXURY_LAMINATED_BOXES](),
    },
    {
      id: 'punched_boxes',
      label: intl.formatMessage({
        id: `products.products_data.punched_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_PUNCHED_BOXES](),
    },
    {
      id: 'wine_boxes',
      label: intl.formatMessage({
        id: `products.products_data.wine_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_WINE_BOXES](),
    },
    {
      id: 'octabin_boxes',
      label: intl.formatMessage({
        id: `products.products_data.octabin_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_OCTABIN_BOXES](),
    },
    {
      id: 'pallet_boxes',
      label: intl.formatMessage({
        id: `products.products_data.pallet_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_PALLET_BOXES](),
    },
    {
      id: 'crate_boxes',
      label: intl.formatMessage({
        id: `products.products_data.crate_boxes.name`,
      }),
      path: ROUTES[Routes.PRODUCTS_CRATE_BOXES](),
    },
  ].filter(({ id }) => id !== translationsKey);

  return (
    <MainTemplate>
      <SEO
        location={location}
        title={intl.formatMessage({
          id: `products_pages.${translationsKey}.seo_title`,
        })}
        description={intl.formatMessage({
          id: `products_pages.${translationsKey}.seo_description`,
        })}
      />

      <div className="container">
        <PageHeadline>
          <FormattedMessage id={`products_pages.${translationsKey}.title`} />
        </PageHeadline>
        <div className="row">
          <div className="col-12 col-md-6">
            <Carousel withIndicators>
              {images.length &&
                images.map((image: IGatsbyImageData, index: number) => (
                  <CarouselItem key={index}>
                    <GatsbyImage
                      image={image}
                      loading="lazy"
                      alt={intl.formatMessage({
                        id: 'products_pages.carousel.image_alt',
                      })}
                    />
                  </CarouselItem>
                ))}
            </Carousel>
          </div>
          <div className="col-12 col-md-6">
            <h2 className={styles.productDescriptionHeadline}>
              <FormattedMessage id="products_pages.description" />
            </h2>
            <p
              className={styles.productDescription}
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({
                  id: `products_pages.${translationsKey}.description`,
                }),
              }}
            />
            <div className={styles.links}>
              <ButtonLink
                className={styles.link}
                to={ROUTES[Routes.CONTACTS]()}
              >
                <FormattedMessage id="products_pages.contacts_link" />
              </ButtonLink>

              <ButtonLink
                className={styles.link}
                to={ROUTES[Routes.FAQ]()}
                color="secondary"
              >
                <FormattedMessage id="products_pages.faq_link" />
              </ButtonLink>
            </div>
          </div>
        </div>
        <div className={styles.similar}>
          <h2>
            <FormattedMessage id="products_pages.similar.headline" />
          </h2>
          <div className={`${styles.otherCategories} d-flex flex-wrap`}>
            {OTHER_CATEGORIES_LINKS.map(({ label, path }) => (
              <Link to={path}>
                <Chip
                  variant="outlined"
                  color="secondary"
                  size="medium"
                  label={label}
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </MainTemplate>
  );
}
